import { inject, Component, Input, SimpleChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { PortfolioService } from '@services/portfolio/portfolio.service';

@Component({
  selector: 'app-sip-static-impact',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './sip-static-impact.component.html',
  styleUrls: ['./sip-static-impact.component.scss']
})
export class SipStaticImpactComponent {

  private portfolioService = inject(PortfolioService);

  @Input() config;
  @Input() hideHeadBanner;
  @Input() hideInfo;
  summary;

  ngOnInit() {
    if (this.config && this.config['order'] && this.config['order']) {
      this.getDonorSummary(this.config['order']['iso_currency']);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.config && changes.config['currentValue']['order'] && changes.config['currentValue']['order']['iso_currency']) {
      this.getDonorSummary(changes.config['currentValue']['order']['iso_currency']);
    }
  }

  /**Get donor summary */
  getDonorSummary(currency) {
    const params = `?currency=${currency}`;
    this.portfolioService.getDonorSummary(params).subscribe((res: any) => {
      this.summary = res.data;
    });
  }

}
